/* Candidate only: load before Kaching/Dawn definitions. Two PDPs; no price/cart writes. */
(() => {
  'use strict';
  const products = {
    '/products/solderstick-push-in-terminal-block-wire-connector': '6627166519462',
    '/products/afm-dfm-disabler-module': '9542199443695'
  };
  const registry = window.customElements;
  if (!registry) return;
  const patched = new WeakSet();
  const gid = value => String(value || '').split('/').pop();
  function request() {
    const product = products[window.location.pathname];
    const variant = new URL(window.location.href).searchParams.get('variant');
    return product && /^\d+$/.test(variant || '') ? {product, variant} : null;
  }
  function attribute(name, raw) {
    const incoming = request();
    if (!incoming || !['other-products', 'deal-block'].includes(name)) return raw;
    let data;
    try { data = JSON.parse(raw); } catch (_) { return raw; }
    if (name === 'other-products' && Array.isArray(data)) {
      let changed = false;
      const result = data.map(product => {
        if (String(product.id) !== incoming.product || !Array.isArray(product.variants)) return product;
        const selected = product.variants.find(v => String(v.id) === incoming.variant && v.availableForSale !== false);
        if (!selected || product.variants[0] === selected) return product;
        changed = true;
        return {...product, variants:[selected, ...product.variants.filter(v => v !== selected)]};
      });
      return changed ? JSON.stringify(result) : raw;
    }
    if (name === 'deal-block' && Array.isArray(data?.dealBars)) {
      const bar = data.dealBars.find(b => b.dealBarType === 'sku' && gid(b.productGID) === incoming.product &&
        [b.variantGID, ...(b.variantGIDs || [])].some(id => gid(id) === incoming.variant));
      return bar ? JSON.stringify({...data, preselectedDealBarId:bar.id}) : raw;
    }
    return raw;
  }
  function patch(name, ctor) {
    if (!['kaching-bundles-block', 'product-info'].includes(name) || patched.has(ctor)) return;
    patched.add(ctor);
    if (name === 'kaching-bundles-block') {
      const original = ctor.prototype.setAttribute;
      ctor.prototype.setAttribute = function(name, value) {
        return original.call(this, name, attribute(name, value));
      };
    } else if (typeof ctor.prototype.updateURL === 'function') {
      const original = ctor.prototype.updateURL;
      ctor.prototype.updateURL = function(url, variantId) {
        const next = new URL(window.location.href);
        const target = new URL(url, next);
        if (!products[next.pathname] || target.origin !== next.origin || target.pathname !== next.pathname) {
          return original.apply(this, arguments);
        }
        if (variantId) next.searchParams.set('variant', String(variantId));
        else next.searchParams.delete('variant');
        this.querySelector('share-button')?.updateUrl(next.href);
        if (this.dataset.updateUrl !== 'false') window.history.replaceState({}, '', next.pathname + next.search + next.hash);
      };
    }
  }
  const define = registry.define;
  registry.define = function(name, ctor, options) {
    patch(name, ctor);
    return define.call(this, name, ctor, options);
  };
  for (const name of ['kaching-bundles-block', 'product-info']) {
    const ctor = registry.get(name);
    if (ctor) patch(name, ctor);
  }
})();
